import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

export type OpportunityState = {
  selectedCategoryId: string | null;
  selectedSubcategory: string | null;
};

const initialState: OpportunityState = {
  selectedCategoryId: null,
  selectedSubcategory: null,
};

export const opportunitySlice = createSlice({
  name: "opportunity",
  initialState,
  reducers: {
    setSelectedCategory: (state, { payload }: PayloadAction<string>) => {
      state.selectedCategoryId = payload;
      state.selectedSubcategory = null;
    },
    setSelectedSubcategory: (state, { payload }: PayloadAction<string>) => {
      state.selectedSubcategory = payload;
    },
    setSelectedCategoryAndSubcategory: (
      state,
      { payload }: PayloadAction<{ categoryId: string; subcategory: string }>
    ) => {
      state.selectedCategoryId = payload.categoryId;
      state.selectedSubcategory = payload.subcategory;
    },
    clearOpportunitySelection: (state) => {
      state.selectedCategoryId = null;
      state.selectedSubcategory = null;
    },
    resetOpportunity: () => initialState,
  },
});

export const {
  setSelectedCategory,
  setSelectedSubcategory,
  setSelectedCategoryAndSubcategory,
  clearOpportunitySelection,
  resetOpportunity,
} = opportunitySlice.actions;

export default opportunitySlice.reducer;
